import { IMActivity } from '../../../types'
import {
  createUnorderedList,
  removeAllElementsWithClass,
} from '../../../../html_utility'
import { narrative } from './narrative'
import { ancillaryContent } from './ancillaryContent'
import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { ISimplifiedNode } from '../../../../../components/ingestion/IngestedTree'
import { IM360Parser } from '../../IM360Parser'

type noteNodeData = [string, string | undefined][]
export function noteNodes(activity: IMActivity) {
  const preNodes: noteNodeData = [
    ['Required Preparation', activity.required_prep],
    ['Time Frame', timeFrameContent(activity)],
    ['Launch', activity.print_component?.launch],
    ['Activity', activity.print_component?.teacher_instructions],
  ]
  const postNodes: noteNodeData = [
    ['Activity Synthesis', activity.activity_synthesis],
    [
      IM360Parser.getInstance().misconceptionsTitle,
      activity.anticipated_misconceptions,
    ],
  ]
  const allNodes = [...preNodes, ...postNodes]
  return {
    preNodes: [
      ...narrative(activity),
      ...ancillaryContent(activity),
      ...annotationNodes(allNodes),
      ...filteredNoteNodes(preNodes),
    ],
    postNodes: filteredNoteNodes(postNodes),
  }
}

const annotations = [
  ['c-annotation--swd', 'Access for Students with Disabilities'],
  ['c-annotation--ell', 'Access for English Language Learners'],
]

export function filteredNoteNodes(nodeData: noteNodeData) {
  const classNames = annotations.map(([className]) => className)
  return nodeData.reduce<ISimplifiedNode[]>((acc, [title, content]) => {
    if (!content) return acc
    const asHtml = parseHtmlString(content)
    removeAllElementsWithClass(asHtml, ...classNames)
    return [
      ...acc,
      IM360Parser.getInstance().createNoteNode({
        title,
        value: asHtml.body.innerHTML,
        studentFacing: false,
      }),
    ]
  }, [])
}

function annotationNodes(nodeData: noteNodeData) {
  return annotations.reduce<ISimplifiedNode[]>((acc, [className, title]) => {
    return [...acc, ...nodeForAnnotation(className, title, nodeData)]
  }, [])
}

function nodeForAnnotation(
  annotation: string,
  title: string,
  nodeData: noteNodeData,
) {
  const [, content] = nodeData.find(([, c]) => c?.includes(annotation)) ?? []
  if (!content) return []
  const asHtml = parseHtmlString(content)
  const value = asHtml.getElementsByClassName(annotation).item(0)?.outerHTML
  if (!value) return []
  return [
    IM360Parser.getInstance().createNoteNode({
      title,
      value,
      studentFacing: false,
    }),
  ]
}

function timeFrameContent(activity: IMActivity) {
  const content = []
  if (activity.time_estimate) {
    content.push(`${activity.time_estimate} min`)
  }
  if (activity.ancillary_content.external_infos) {
    content.push(
      ...activity.ancillary_content.external_infos.map(({ title }) => title),
    )
  }
  if (content.length) return createUnorderedList(content)
}
